
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.583 17.25L.75 6.25h16.5l-1.833 11H2.583zm4.584-5.5h3.666c.26 0 .478-.088.653-.264a.887.887 0 00.264-.653.887.887 0 00-.264-.653.887.887 0 00-.653-.263H7.167a.887.887 0 00-.653.263.887.887 0 00-.264.653c0 .26.088.478.264.653a.887.887 0 00.653.264zM3.5 5.333a.887.887 0 01-.653-.263.887.887 0 01-.264-.653c0-.26.088-.478.264-.653A.887.887 0 013.5 3.5h11c.26 0 .477.088.653.264a.887.887 0 01.264.653c0 .26-.088.477-.264.653a.887.887 0 01-.653.263h-11zm1.833-2.75a.887.887 0 01-.653-.263.887.887 0 01-.263-.653c0-.26.088-.478.263-.653A.887.887 0 015.333.75h7.334c.26 0 .477.088.653.264a.887.887 0 01.263.653c0 .26-.088.477-.263.653a.887.887 0 01-.653.263H5.333z"}})])
          )
        }
      }
    